import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { action } from 'satcheljs';

/**
 * Initialize the calendar channel picker
 */
export const initializeCalendarChannelPicker = action(
    'initializeCalendarChannelPicker',
    (event: CalendarEvent) => ({ event })
);
